$(document).ready(function() {

  var sideNavLinkActive = $('.js-side-nav-link-active');

  sideNavLinkActive.on('click', function (e) {
    e.preventDefault();
    $('.js-dc-side-nav').toggleClass('dc-side-nav--open');
  });

});
